// components/ApproximatedVehicleMarker.jsx
import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { getFullHeadsign } from '../utils/headsigns';
import { formatDelayHuman } from '../utils/time';

/**
 * Tworzy ikonę markera dla pojazdu z przybliżoną pozycją.
 * Wizualnie odróżnia się od zwykłych markerów:
 * - Przerywaną obwódką
 * - Mniejszą przezroczystością
 * - Oznaczeniem "~" (tylda = przybliżenie)
 */
function createApproximatedIcon(lineNumber) {
  const lineNum = parseInt(lineNumber);
  const isTrolleybus = lineNum >= 10 && lineNum <= 99;
  const color = isTrolleybus ? '#B45309' : '#F97316';
  const str = String(lineNumber);
  const fontSize = str.length >= 4 ? 9 : str.length === 3 ? 11 : 13;

  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="26" viewBox="0 0 40 26"
         overflow="visible" style="opacity: 0.82; filter: drop-shadow(0 2px 3px rgba(0,0,0,0.25));">
      <rect x="2" y="2" width="36" height="22" rx="6" fill="${color}"/>
      <rect x="2" y="2" width="36" height="22" rx="6" fill="none" stroke="white" stroke-width="2"/>
      <text x="20" y="13" text-anchor="middle" dominant-baseline="middle" fill="white"
            font-family="system-ui,-apple-system,sans-serif" font-weight="800" font-size="${fontSize}">${str}</text>
    </svg>
  `;

  return L.divIcon({
    className: 'custom-vehicle-icon-wrapper',
    html: svg,
    iconSize: [40, 26],
    iconAnchor: [20, 13],
    popupAnchor: [0, -13],
  });
}

function ApproximatedVehicleMarker({ vehicle, onClick }) {
  const icon = createApproximatedIcon(vehicle.routeShortName);
  const headsign = getFullHeadsign(vehicle.headsign);

  return (
    <Marker
      position={[vehicle.lat, vehicle.lon]}
      icon={icon}
      eventHandlers={{ 
        click: () => {
          if (onClick) onClick(vehicle);
        }
      }}
    />
  );
}

export default ApproximatedVehicleMarker;
